<div class="summaryPage-Preview-Window">
  <div
    *ngIf="isPrintWarning"
    class="print-warning-text {{
      isPrintClicked ? 'hide-warningText' : 'show-warningText'
    }}">
    {{ warningMessage }}
  </div>

  <div *ngIf="dataSource" class="print-page {{ pageSize }}">
    <div class="logo" title="PACTrak">
      <img src="assets/Logo.svg" alt="" />
    </div>

    <div>
      <table class="ibc-print-table">
        <thead>
          <tr>
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <th
                *ngIf="
                  commonTableService.displaySelectedColumnsToTable(
                    item.key,
                    summaryCustomiseTableColumns,
                    displayedColumns
                  )
                "
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <div class="ibc-body-text-large-bold table-text">
                  {{ item.label }}
                </div>
              </th>
            </ng-container>
          </tr>
          <tr *ngIf="showSetRangeSubheader" >
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <th
                *ngIf="commonTableService.displaySelectedColumnsToTable(item.key, summaryCustomiseTableColumns, displayedColumns)"
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <ng-container *ngIf="item.key === 'setRange'; else blankCell">
                  <div class="range-subheader-row">
                    <div class="range-subheader">Start No.</div>
                    <div class="range-subheader">End No.</div>
                    <div class="range-subheader">Last Used No.</div>
                    <div class="range-subheader">Priority</div>
                  </div>
                </ng-container>
                <ng-template #blankCell>
                  <!-- keep other headers empty in this row -->
                </ng-template>
              </th>
            </ng-container>
          </tr>
           <tr *ngIf="showApChargeSubheader">
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <th
                *ngIf="commonTableService.displaySelectedColumnsToTable(item.key, summaryCustomiseTableColumns, displayedColumns)"
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <ng-container *ngIf="item.key === 'apChargeCodeDetails'; else blankCellAP">
                  <div class="range-subheader-row">
                    <div class="range-subheader">AP Charge Code</div>
                    <div class="range-subheader">IBC Charge Code</div>
                    <div class="range-subheader">Charge Type</div>
                    <div class="range-subheader">Agent Charge Description</div>
                  </div>
                </ng-container>
                <ng-template #blankCellAP>
                </ng-template>
              </th>
            </ng-container>
          </tr>
           <tr *ngIf="showSetCurrecnySubheader">
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <th
                *ngIf="commonTableService.displaySelectedColumnsToTable(item.key, summaryCustomiseTableColumns, displayedColumns)"
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <ng-container *ngIf="item.key === 'viewDetails'; else blankCellAP">
                  <div class="range-subheader-row">
                    <div class="range-subheader">Previous Conversion Rate</div>
                    <div class="range-subheader">Updated Conversion Rate</div>
                    <div class="range-subheader">Updated Date</div>
                  </div>
                </ng-container>
                <ng-template #blankCellAP>
                </ng-template>
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let element of dataSource">
          <tr [class.has-linked-shipments]="!!element['linkedShipments']?.length">
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <td
                *ngIf="
                  commonTableService.displaySelectedColumnsToTable(
                    item.key,
                    summaryCustomiseTableColumns,
                    displayedColumns
                  )
                "
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'"
              >
                <ng-container [ngSwitch]="item.key">

                  <ng-container *ngSwitchCase="'setRange'">
                    <div style="font-size: 11px;">
                      <div
                        *ngFor="let range of element[item.key]"
                        class="range-values-row"
                      >
                        <div class="range-value">{{ range.startNumber }}</div>
                        <div class="range-value">{{ range.endNumber }}</div>
                        <div class="range-value">{{ range.lastUsedNumber }}</div>
                        <div class="range-value">{{ range.priority }}</div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'apChargeCodeDetails'">
                    <div style="font-size: 11px;">
                      <div
                        *ngFor="let ap of element[item.key]"
                        class="range-values-row"
                      >
                        <div class="range-value">{{ ap.agentChargeCode }}</div>
                        <div class="range-value">{{ ap.ibcChargeCode }}</div>
                        <div class="range-value">{{ ap.chargeType }}</div>
                        <div class="range-value">{{ ap.description }}</div>
                      </div>
                    </div>
                  </ng-container>                  

                   <ng-container *ngSwitchCase="'viewDetails'">
                    <div style="font-size: 11px;">
                      <div
                        *ngFor="let cr of element['details']"
                        class="range-values-row"
                      >
                        <div class="currency-details">{{ cr.previousConversionRate }}</div>
                        <div class="currency-details">{{ cr.updatedConversionRate }}</div>
                        <div class="currency-details">{{ cr.updatedDate }}</div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Default -->
                  <ng-container *ngSwitchDefault>
                    <div
                      class="ibc-body-text-regular table-text {{
                        commonTableService.isHyperlink(item.label, isFrom)
                          ? 'text-hyperlink'
                          : ''
                      }}"
                    >
                      {{
                        item.key !== 'date'
                          ? element[item.key]
                          : (element.date | date: dateFormat)
                      }}
                    </div>
                  </ng-container>

                </ng-container>
              </td>

            </ng-container>
          </tr>
          <!-- PAC-24667: linked shipments of a master, printed inside the master's row group -->
          <tr
            *ngFor="let linked of element['linkedShipments']; let last = last"
            class="linked-shipment-row"
            [class.last-linked-shipment]="last">
            <ng-container *ngFor="let item of summaryCustomiseTableColumns">
              <td
                *ngIf="
                  commonTableService.displaySelectedColumnsToTable(
                    item.key,
                    summaryCustomiseTableColumns,
                    displayedColumns
                  )
                "
                [style.flex]="'0 0 ' + item.defaultPrintWidth + 'px'">
                <div
                  class="ibc-body-text-regular table-text {{
                    item.key === linkedShipmentColumnKey
                      ? 'linked-shipment-ext'
                      : ''
                  }}">
                  {{
                    item.key !== 'date'
                      ? linked[item.key]
                      : (linked.date | date: dateFormat)
                  }}
                </div>
              </td>
            </ng-container>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <button
    class="ibc-medium-button ibc-primary-default-button cursor preview-print-btn {{
      isPrintClicked ? 'hide-btn' : 'show-btn'
    }}"
    (click)="print()">
    <span class="ibc-body-text-regular">
      {{ popupButtons.Print }}
    </span>
  </button>
</div>
